import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MAPPA_URL } from "../../config";
import { trackMappaClick } from "../../analytics";

export const StickyCta = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.75);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-40 bg-gradient-to-t from-ink via-ink/90 to-transparent p-4 pb-5 md:hidden"
          data-testid="sticky-cta-bar"
        >
          <motion.a
            href={MAPPA_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackMappaClick("sticky-cta")}
            data-testid="sticky-cta"
            whileTap={{ scale: 0.97 }}
            className="block w-full cursor-pointer rounded-full bg-gold py-4 text-center text-xs font-semibold uppercase tracking-[0.2em] text-black shadow-[0_0_40px_-10px_rgba(255,211,77,0.6)]"
          >
            Richiedi la Mappa del Tempio
          </motion.a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
